import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputRadioAttr = makeAttrStruct([
    ['name'],
    ['value'],
    ['class'],
    ['checked', false],
    ['type', HTTPINPUTTYPE.RADIO]
]);
export const inputRadioData = makeDataStruct([]);
export const inputRadioModel = makeStruct([
    ['attributes', inputRadioAttr],
    ['data', inputRadioData]
]);
// Simplified Model
export function inputRadio(name, value, className, checked) {
    return {
        attributes: inputRadioAttr(name, value, className, checked),
        data: inputRadioData()
    };
}
// Class
export default class INPUTRADIO extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
    /** Override getValue to only return value if radio button is checked */
    getValue() {
        return this.el.checked ? this.el.value : null;
    }
}
